import { WebLayout } from 'components/Layout';
import React, { useState } from 'react';
import mockup from 'assets/mockup.png';
import { BottomSheetModal } from 'components/Elements';

export function Landing() {
  const [iosModalOpen, setIosModalOpen] = useState(false);
  return (
    <WebLayout>
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-gray-100 via-white to-gray-200"></div>

        <div className="relative max-w-6xl mx-auto px-4 py-24 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold leading-tight">
              Clear your space,
              <br />
              <div className="text-gray-500">Make some cash</div>
            </h1>

            <p className="mt-5 text-gray-600 max-w-md">
              Dejunk connects you with people around you who actually need what you don’t. No noise.
              No stress. Just fast local deals.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <a
                href="#download"
                className="bg-black text-white px-6 py-3 rounded-xl font-medium hover:scale-105 transition text-center"
              >
                Download App
              </a>

              <a
                href="#how"
                className="border px-6 py-3 rounded-xl font-medium hover:bg-gray-100 text-center"
              >
                How it works
              </a>
            </div>
          </div>

          <div className="relative flex justify-center">
            <img src={mockup} className="w-80" />
          </div>
        </div>
      </section>

      <section id="features" className="py-20">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-semibold">Built for Speed & Simplicity</h2>

          <div className="grid md:grid-cols-3 gap-8 mt-12">
            <div className="p-6 rounded-2xl border hover:shadow-lg transition">
              <div className="text-2xl mb-3">📍</div>
              <h3 className="font-semibold">Location First</h3>
              <p className="text-sm text-gray-600 mt-2">
                Only see items near you, unless you extend your radius. No irrelevant listings.
              </p>
            </div>

            <div className="p-6 rounded-2xl border hover:shadow-lg transition">
              <div className="text-2xl mb-3">⚡</div>
              <h3 className="font-semibold">Instant Posting</h3>
              <p className="text-sm text-gray-600 mt-2">
                Upload and go live in seconds. No complicated steps.
              </p>
            </div>

            <div className="p-6 rounded-2xl border hover:shadow-lg transition">
              <div className="text-2xl mb-3">📞</div>
              <h3 className="font-semibold">Direct Contact</h3>
              <p className="text-sm text-gray-600 mt-2">
                Buyers call you instantly. No middlemen. No waiting.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section id="how" className="bg-gray-50 py-20">
        <div className="max-w-6xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-semibold">How It Works</h2>

          <div className="grid md:grid-cols-3 gap-10 mt-12 text-left">
            <div>
              <div className="text-sm text-gray-400">STEP 1</div>
              <h3 className="font-semibold mt-1">Download the App</h3>
              <p className="text-gray-600 text-sm mt-2">
                Get Dejunk on your phone and create an account.
              </p>
            </div>

            <div>
              <div className="text-sm text-gray-400">STEP 2</div>
              <h3 className="font-semibold mt-1">Post Your Item</h3>
              <p className="text-gray-600 text-sm mt-2">Add photos, description, and price.</p>
            </div>

            <div>
              <div className="text-sm text-gray-400">STEP 3</div>
              <h3 className="font-semibold mt-1">Get Calls</h3>
              <p className="text-gray-600 text-sm mt-2">Buyers near you contact you directly.</p>
            </div>
          </div>
        </div>
      </section>

      <section id="download" className="py-24 text-center">
        <div className="max-w-xl mx-auto px-4">
          <h2 className="text-3xl font-semibold">Your marketplace is already around you</h2>

          <p className="text-gray-600 mt-4">Download Dejunk and start clearing space today.</p>

          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://play.google.com/store/apps/details?id=com.ashitacreatives.dejunk"
              className="bg-black text-white px-6 py-3 rounded-xl font-medium hover:scale-105 transition"
            >
              Download for Android
            </a>

            <button
              onClick={() => setIosModalOpen(true)}
              className="border px-6 py-3 rounded-xl font-medium hover:bg-gray-100"
            >
              Download for iOS
            </button>
          </div>
        </div>
      </section>

      <BottomSheetModal
        visible={iosModalOpen}
        onClose={() => setIosModalOpen(false)}
        title="iOS Access"
      >
        <div className="space-y-3 text-center py-2">
          <p className="text-sm text-gray-600 leading-relaxed">
            We’re currently fine-tuning Dejunk for Apple devices to ensure a seamless,
            high-performance experience from day one.
          </p>

          <p className="text-sm text-gray-500">
            In the meantime, the Android version is fully live and ready to use.
          </p>

          <button
            onClick={() => setIosModalOpen(false)}
            className="mt-4 bg-black text-white px-5 py-2 rounded-xl text-sm hover:scale-105 transition"
          >
            Got it
          </button>
        </div>
      </BottomSheetModal>
    </WebLayout>
  );
}
